import axiosInstance from "./AxiosInstance";

export function getList(data) {
  return axiosInstance.post("admin/candidate/job-fair-participants", data);
}

export function getCandidateUpdateCompliance(data) {
  return axiosInstance.post("admin/user/login-reminder/listing", data);
}

export function listStatus(data) {
  return axiosInstance.post("sub-recruiter/downloaded-resume", data);
}

// export function getTimeLog(data) {
//   return axiosInstance.post("sub-recruiter/login-logout-duration", data);
// }

// export function getProfileView(data) {
//   return axiosInstance.post("sub-recruiter/checkout-candidates", data);
// }

export function recruiterPlanHistory(data) {
  return axiosInstance.post("admin/candidate/filter-plan-by-recruiter", data);
}

export function recruiterHistoryPlanDetail(data) {
  return axiosInstance.post("admin/candidate/plan/candidates", data);
}

export function updatePlan(data) {
  return axiosInstance.post("admin/plan/create-recruiter-billing", data);
}

export function jobsApplicants(data) {
  return axiosInstance.post("admin/candidate/user-jobs-with-applicants", data);
}
